/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_2Inputs */

const en_bot_does_2 = /** @type {(inputs: Bot_Does_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens one page at a time with at least 0.5 seconds between requests, and never dissects the same site twice at once.`)
};

const id_bot_does_2 = /** @type {(inputs: Bot_Does_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka satu halaman sekaligus dengan jeda minimal 0,5 detik, dan tidak pernah membedah situs yang sama dua kali bersamaan.`)
};

/**
* | output |
* | --- |
* | "Opens one page at a time with at least 0.5 seconds between requests, and never dissects the same site twice at once." |
*
* @param {Bot_Does_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_2 = /** @type {((inputs?: Bot_Does_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_2(inputs)
	return en_bot_does_2(inputs)
});